import React, { Component } from 'react'
import LoadMask from 'Utils/LoadMask/LoadMask';
import ComparativoFlujoCajaForm from './ComparativoFlujoCajaForm';

export default class ComparativoFlujoCajaReport extends Component {
    componentDidMount() {
        const { page } = this.props;
        this.props.getDollar();
        this.props.read(page);
    }
    componentDidUpdate(prevProps) {
        if (this.props.tab !== prevProps.tab) {
            this.props.getDollar();
            this.props.read();
        }
    }

    saveChanges = (data) => {
        const currency = this.props.currency;
        let saldo_inicial = 0;
        if (data) {
            if (data.summary) {
                if (data.summary[0]) {
                    if (data.summary[0].enero) {
                        saldo_inicial = data.summary[0].enero;
                    }
                }
            }
        }

        this.props.guardarCambios({ ...data, currency, saldo_inicial });
    };

    getPermissions = () => {
        const { getMe } = this.props;
        getMe();
    }

    render() {
        const { updateData, loader, item } = this.props;
        return (
            <div className="mb-4 col-12 comparativo-flujo-caja">
                <LoadMask loading={loader} blur>
                    <ComparativoFlujoCajaForm
                        onSubmit={this.saveChanges}
                        updateData={updateData}
                        item={item}
                        editando={true}
                        permisos={this.getPermissions}
                        {...this.props}
                    />
                </LoadMask>
            </div>
        )
    }
}

